import { useState } from "react";
import { Eye, EyeOff, Shield } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useT } from "../lib/useLanguage";

export default function BlurredMessage({ message, onReveal, onDecline }) {
  const t = useT();
  const [revealed, setRevealed] = useState(false);

  function handleReveal() {
    setRevealed(true);
    onReveal?.();
  }

  return (
    <div className="rounded-xl border border-border p-4" style={{ backgroundColor: "#FFFAF5" }}>
      <div className="flex items-center gap-1.5 mb-2 text-xs text-muted-foreground">
        <Shield className="h-3 w-3" style={{ color: "#FF6B4A" }} />
        <span>{t("msg_blur_hint")}</span>
      </div>
      <div className="relative">
        <p className={`text-sm leading-relaxed text-foreground transition-all duration-500 ${revealed ? "" : "blur-sm select-none"}`}>
          {message}
        </p>
        {!revealed && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="flex gap-2">
              <Button size="sm" className="rounded-full gap-1.5 text-xs" style={{ backgroundColor: "#FF6B4A" }} onClick={handleReveal}>
                <Eye className="h-3.5 w-3.5" />{t("msg_reveal")}
              </Button>
              <Button size="sm" variant="outline" className="rounded-full text-xs" onClick={onDecline}>
                {t("msg_decline")}
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}